module.exports = __webpack_public_path__ + "img/cohere.327454c1.jpg";